module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAmCAMAAAAcJyCnAAAAUVBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////8IN+deAAAAGnRSTlMAlqUi5Ys61aFDCPw1EAwFwJGFg3RsINqpS8W1wQgAAACDSURBVCjP3dK5DsIwFETRSfAWr9mB+f8PRTLYCpG7NIhbnmZe8XC9QQ8nSQ8FSU72SxdKdCTlEb1jl7U/YLyzoQtb2v+AmqZ6UdTA3koxmLc6tQuWNPD0UIIzRtbWtAUAYUsrayNmCpUXdEWxK0d2WWPdsp/LzvV/rLKpdiIl2r97uRehkBLPN5r7VgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/progressPage/num-4.png
// module id = fHel
// module chunks = 1